import { newDiv, createImage } from '../RenderUtils';
import { addAnalyticsAttribute } from '../../../helpers/analytics';
import { CONTROLS_EVENTS_GA } from './Constants';

export class LogoInfo {
  constructor(container) {
    this.container = container;
  }

  render() {
    const logoImageNode = createImage('/images/map/lun_mini.png');
    logoImageNode.classList.add('LogoInfo-image');

    const logoLinkNode = document.createElement('a');
    logoLinkNode.href = 'https://lun.ua';
    logoLinkNode.target = '_blank';
    logoLinkNode.appendChild(logoImageNode);
    logoLinkNode.classList.add('LogoInfo-link');

    addAnalyticsAttribute(logoLinkNode, CONTROLS_EVENTS_GA.LOGO);

    const logoInfoNode = newDiv(logoLinkNode, this.container);
    logoInfoNode.classList.add('LogoInfo');
  }
}
